import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import camelcaseKeys from 'camelcase-keys';
import { isObject } from 'lodash-es';
import snakecaseKeys from 'snakecase-keys';

const bq = fetchBaseQuery({
  baseUrl: '/api',
});

const consoleApiSlice = createApi({
  reducerPath: 'consoleApi',
  tagTypes: ['User', 'Candidates', 'Candidate'],
  baseQuery: async (queryArgs, ...args) => {
    if (isObject(queryArgs)) {
      if (queryArgs.body) {
        queryArgs.body = snakecaseKeys(queryArgs.body, { deep: true });
      }
      if (queryArgs.params) {
        queryArgs.params = snakecaseKeys(queryArgs.params, { deep: true });
      }
    }
    const result = await bq(queryArgs, ...args);
    /**
    result = {
      data?: {data: ...},
      error?: {
        data: {data: ...},
        status: 401
      },
      meta
    }

    == After Transformation ==

    result = {
      data?: {...},
      error?: {
        data: {...},
        status: xxx
      }
    }
    */

    if (result.data) {
      result.data = camelcaseKeys(result.data.data, { deep: true });
    }
    if (result.error) {
      result.error.data = camelcaseKeys(result.error.data.data, { deep: true });
    }
    return result;
  },
  endpoints: () => ({}),
});

export default consoleApiSlice;
